<script setup lang="ts">
import type { Media_Plain } from '@webamboos/admin'
import 'swiper/css'
import { Swiper, SwiperSlide } from 'swiper/vue'
import { useWorkshop } from '~/composables/cms/workshop'

const props = defineProps<{
  items: Media_Plain[]

  first?: boolean
}>()

const { workshop } = useWorkshop()
</script>

<template>
  <div v-if="workshop.team!.image_grid" class="relative z-0 justify-center gap-4">
    <swiper
      class="!overflow-visible"
      :initialSlide="props.first ? 4 : 6"
      slidesPerView="auto"
      grabCursor
      centeredSlides
    >
      <swiper-slide
        v-for="({ image }, i) in props.items"
        :key="image.id"
        :index="i"
        :style="{ height: 'auto !important', width: 'auto !important' }"
        class="mr-8"
      >
        <NuxtImg
          :src="image.url"
          fit="cover"
          :alt="image.alternativeText || image.name"
          class="h-64 max-h-72 w-auto rounded-lg object-cover transition-all md:max-h-96 lg:max-h-[36rem]"
        />
      </swiper-slide>
    </swiper>
  </div>
</template>
